import {user} from '../../user/user.js';

export default 'nickname';
export const nicknameFilter = filter;

function filter() {
  return (input: string | undefined, amateur: Amateur) => {
    if (typeof input != 'string') {
      return input;
    }
    let res = input.replace(/(@nickname)/g, user.nickname);
    if (amateur) {
      res = res.replace(/@amateurName/g, amateur.getNickname());
    }
    return res;
  };
}
